import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Geist, sans-serif',
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontFamily: 'Geist, sans-serif',
        },
      },
    },
  },
});

export default theme;
